define( [ "./selector-sizzle" ], function() {
	"use strict";
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 24
// module chunks = 0